import { useEnumStore } from '@stores/enum';
import { transformParameterQuery } from '@utils/parameters';

export default function (values) {
  const enums = useEnumStore();
  const parameters = transformParameterQuery(values, 'p', enums.eshopParameters)
    .filter(parameter => parameter.valueText === undefined);
  return parameters.length ? parameters : null;
}
